import "./Stats.scss";
import NGrams from "../../components/NGrams/NGrams";
import MyHeatmap from "../../components/Heatmap/Heatmap";
import BarChart from "../../components/BarChart/BarChart";

const Stats = ({ postsData, searchTerm, timeInterval, totalPosts }) => {
  const timePeriod = timeInterval.includes("all") ? (
    <span className="stats__text--highlighted">of all time</span>
  ) : (
    <>
      over the last
      <span className="stats__text--highlighted">
        {" "}
        {timeInterval.toLowerCase()}
      </span>
    </>
  );

  return (
    <>
      <section className="stats">
        <div className="stats__title-container">
          <h2 className="stats__title">Data Analysis</h2>
          <p className="stats__description">
            Analysing the top{" "}
            <span className="stats__text--highlighted">{totalPosts}</span> posts
            of <span className="stats__text--highlighted">r/{searchTerm}</span>{" "}
            {timePeriod}. Top posts are defined as those posts with the largest
            number of upvotes within the specified time interval.
          </p>
        </div>
        <div className="stats__container-top">
          <MyHeatmap
            title="Top Posts by Score"
            subredditData={postsData.heatmapScores}
          />
        </div>
        <div className="stats__container-mid">
          <BarChart
            barChartData={Object.values(postsData.totalDayOfWeek)}
            horizontal={false}
            title="Top Posts by Day of Week"
            xLabel="Day of Week"
            yLabel="Percentage of Total"
            seriesName="Percentage of Total"
            topN={7}
          />
        </div>
      </section>
      <NGrams barChartData={postsData.barChartTerms} postsData={postsData} />
    </>
  );
};

export default Stats;
